import { makeStyles, createStyles } from '@material-ui/core';
import { Colors } from '../../../../layout/theme-next';

export default makeStyles(theme =>
  createStyles({
    boxContainer: {
      height: 46,
      display: 'flex',
      alignItems: 'center',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      '&:hover': {
        backgroundColor: Colors.hover,
      },
      '&:hover $icons': {
        visibility: 'visible',
      },
    },
    span: {
      flex: 1,
    },
    icons: {
      display: 'flex',
      alignItems: 'center',
      visibility: 'hidden',
    },
    editIcon: {
      height: 17,
      width: 17,
      marginRight: theme.spacing(2),
      cursor: 'pointer',
    },
    editIconDisable: {
      color: Colors.textDisabled,
    },
    deleteIcon: {
      color: Colors.error,
    },
  }),
);
